import { useShow } from '../../../../hooks/useShow'
import { DialogContent, Modal } from '../../../../components/Modal/Modal'
import React from 'react'
import { IItem } from '../../../../api/types/item'
import { ItemForm } from '../ItemForm/ItemForm'
import { useQueryClient } from '@tanstack/react-query'
import { itemsQueryKey } from '../../../../api/queries'

interface Props {
  children: (showModal: () => void) => any
  title: string
  item?: IItem
}

export const ItemFormModal: React.FC<Props> = ({ children, title, item }) => {
  const { show, doHide, doShow } = useShow()
  const queryClient = useQueryClient()
  return (
    <>
      {children(doShow)}
      <Modal open={show} onClose={doHide} title={title}>
        <DialogContent>
          <ItemForm
            item={item}
            afterSuccess={() => {
              queryClient.invalidateQueries(itemsQueryKey())
              doHide()
            }}
          />
        </DialogContent>
      </Modal>
    </>
  )
}
